<template>
    <div v-if="!category?.customFields?.nd_tweakwise_hide_in_category_tree" class="mb-3 last:mb-0">
        <CategoryLink
            :category-id="category.id"
            :to="'/' + category.seoUrls?.[0]?.seoPathInfo"
            @click="
                () => {
                    mobileFiltersMenuStore.closeMenu();
                    onCategoryClick(category.id);
                }
            "
            class="mb-0 !flex cursor-pointer items-center text-sm font-normal"
            :class="[{ '!font-black': isSelected }, { 'pointer-events-none': isSelected }]">
            <span class="flex-1">{{ category.translated.name }}</span>
        </CategoryLink>
        <div v-if="activeChildren.length > 0" class="mt-4 border-l-2 border-green-500 pl-4">
            <CategoryTreeItem
                v-for="child in activeChildren"
                :key="child.id"
                :category="child"
                :current-category-id="currentCategoryId" />
        </div>
    </div>
</template>

<script setup lang="ts">
    interface Category {
        id: string;
        parentId?: string;
        active?: boolean;
        translated: {
            name: string;
        };
        seoUrls: Array<{ seoPathInfo: string }>;
        children?: Category[];
    }

    const props = defineProps<{
        category: Category;
        currentCategoryId?: string;
    }>();

    const keepFilters = useKeepFilters();
    const tweakwiseCategoryNames = inject<Ref<Set<string> | null>>('tweakwiseCategoryNames', ref(null));
    const route = useRoute();
    const mobileFiltersMenuStore = useMobileFiltersMenuStore();
    const isSelected = computed(() => props.category.id === props.currentCategoryId);

    const activeChildren = computed(() => {
        if (!props.category.children) return [];
        let children = props.category.children.filter(child => child.active);

        if (!keepFilters.value && tweakwiseCategoryNames.value) {
            children = children.filter(child => tweakwiseCategoryNames.value!.has(child.translated.name.toLowerCase()));
        }
        return children;
    });

    const { apiClient } = useShopwareContext();
    function onCategoryClick(categoryId: string) {
        if (!keepFilters.value || Object.keys(route.query).length === 0) prefetchPlpListing(apiClient, categoryId);
    }
</script>
